import Modal from "@components/modal/modal";
import ModalTitle from "@components/modal/modal-title";

import {
  ComplianceProgramListItemFragment,
  GetComplianceProgramQuery,
} from "../../../types/graphql-schema";
import ComplianceProgramDetails from "./compliance-program-details";

const ComplianceProgramDetailsDialog = ({
  complianceProgram,
  onClose,
}: {
  complianceProgram:
    | NonNullable<GetComplianceProgramQuery["complianceProgram"]>
    | ComplianceProgramListItemFragment;
  onClose: () => void;
}) => {
  return (
    <Modal onClose={onClose} className="">
      <div
        className="flex flex-col text-sm max-h-[90vh] overflow-y-auto"
        aria-label="Program details dialog"
      >
        <div className="p-6">
          <ModalTitle onClose={onClose}>
            {`Program Details: ${complianceProgram.title}`}
          </ModalTitle>
        </div>

        <div className="px-6 pb-6">
          <ComplianceProgramDetails complianceProgram={complianceProgram} />
        </div>
      </div>
    </Modal>
  );
};
export default ComplianceProgramDetailsDialog;
